// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ot-coach-tools {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ot-coach-tools__hint {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.62);
}

.ot-coach-tools__row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
}

.ot-coach-tools__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.9rem;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/OffTableCoachToolsEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".ot-coach-tools {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ot-coach-tools__hint {\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  color: rgba(0, 0, 0, 0.62);\n}\n\n.ot-coach-tools__row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 16px;\n}\n\n.ot-coach-tools__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
